import { render } from "./constrafaq.vue?vue&type=template&id=006665dc"
import script from "./constrafaq.vue?vue&type=script&lang=js"
export * from "./constrafaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__